export default "__VITE_ASSET__CdtUu15E__"